import { render, staticRenderFns } from "./provider-manageattendees.vue?vue&type=template&id=65c14af6&scoped=true"
import script from "./provider-manageattendees.vue?vue&type=script&lang=js"
export * from "./provider-manageattendees.vue?vue&type=script&lang=js"
import style0 from "./provider-manageattendees.vue?vue&type=style&index=0&id=65c14af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c14af6",
  null
  
)

export default component.exports